module.exports = __webpack_public_path__ + "img/promo-agosto-swift.f5379879.jpg";